import React, { useState } from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";

type AddAuthorModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (params: { emailList: string }) => void;
};
export const AddAuthorsByListModal: React.FunctionComponent<
  AddAuthorModalProps
> = (props: AddAuthorModalProps) => {
  const [emailList, setEmailList] = useState("");
  return (
    <Modal isOpen={props.isOpen}>
      <div className="modal-header">
        <h5 className="modal-title">Add Subscription Author</h5>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={props.onClose}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <ModalBody>
        <div className="form-group">
          <label>New Authors from CSV</label>
          <textarea
            rows={5}
            className="form-control"
            placeholder="Comma,separated,emails"
            onChange={(e) => setEmailList(e.currentTarget.value)}
          ></textarea>
        </div>
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-light" onClick={props.onClose}>
          Close
        </button>
        <button
          className="btn btn-primary"
          onClick={() => props.onSubmit({ emailList })}
        >
          Submit
        </button>
      </ModalFooter>
    </Modal>
  );
};
